// This file was automatically generated from appanalytics.reports.mu.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appanalytics.reports.mu');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.error) {
    output.append('<p class="el8QueueEmpty">Sorry, this report is not available.</p>');
  } else {
    output.append('<div id="mu-results-tab-header" class="el8Tab padt10"></div><div id="mu-results-mips-interoperability-measures-section" class="tab-section" data-name="mips_interoperability_measures">');
    el8.template.appanalytics.reports.mu.muReportTitle({title: 'MIPS Promoting Interoperability', period: opt_data.period, end_date: opt_data.end_date}, output);
    output.append('<p class="el8Spacer">Time periods where provider accounts are disabled will not be available for reporting</p><table class="practiceReportTable"><thead><tr><th></th><th>Measure Type</th><th class="el8EmphasisText">Goal</th><th><p class="el8StandardFontSize">Meets Criteria<br />(%)</p></th><th><p class="el8StandardFontSize">Meets Criteria<br />(Num)</p></th><th><p class="el8StandardFontSize">Total Eligible<br />(Den)</p></th><th></th></tr></thead><tbody>');
    el8.template.appanalytics.reports.mu.muReportTable({name: 'Objectives', desc: 'Must satisfy all objectives', list: opt_data.mips_interoperability_measures.core_set_measures, col_count: 8}, output);
    output.append('</tbody></table></div><div id="mu-results-medicaid-interoperability-measures-section" class="tab-section" data-name="medicaid_interoperability_measures">');
    el8.template.appanalytics.reports.mu.muReportTitle({title: 'Medicaid Promoting Interoperability', period: opt_data.period, end_date: opt_data.end_date}, output);
    if (opt_data.medicaid_interoperability_report_disabled) {
      output.append('<p class="el8Spacer">This CMS program is not active for year ', soy.$$escapeHtml(opt_data.year), '.</p>');
    } else {
      output.append('<p class="el8Spacer">Time periods where provider accounts are disabled will not be available for reporting</p><table class="practiceReportTable"><thead><tr><th></th><th class="el8EmphasisText">Goal</th><th><p class="el8StandardFontSize">Meets Criteria<br />(%)</p></th><th><p class="el8StandardFontSize">Meets Criteria<br />(Num)</p></th><th><p class="el8StandardFontSize">Total Eligible<br />(Den)</p></th><th></th></tr></thead><tbody>');
      el8.template.appanalytics.reports.mu.muReportTable({name: 'Objectives', desc: 'Must satisfy all objectives', list: opt_data.medicaid_interoperability_measures.core_set_measures}, output);
      output.append('</tbody></table>');
    }
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.percent = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appanalytics.reports.mu.rowLabel({c: opt_data.c, show_check: opt_data.c.data.percent >= opt_data.c.required.percent}, output);
  el8.template.appanalytics.reports.mu.rowMeasureType({c: opt_data.c}, output);
  output.append('<td class="required-percent el8EmphasisText', (opt_data.c.inactive) ? ' el8DismissTextImportant' : '', '" data-name="', soy.$$escapeHtml(opt_data.c.name), '">', (opt_data.c.required) ? soy.$$escapeHtml(opt_data.c.required.percent) + '%' : '', '</td>');
  el8.template.appanalytics.reports.mu.rowComputedPercentage({c: opt_data.c}, output);
  el8.template.appanalytics.reports.mu.rowNumerator({c: opt_data.c}, output);
  el8.template.appanalytics.reports.mu.rowDenominator({c: opt_data.c}, output);
  el8.template.appanalytics.reports.mu.rowViewListBtn({c: opt_data.c}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.patient_count = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appanalytics.reports.mu.rowLabel({c: opt_data.c, show_check: opt_data.c.data.num >= opt_data.c.required.patient_count}, output);
  el8.template.appanalytics.reports.mu.rowMeasureType({c: opt_data.c}, output);
  output.append('<td class="required-percent el8EmphasisText', (opt_data.c.inactive) ? ' el8DismissTextImportant' : '', '" data-name="', soy.$$escapeHtml(opt_data.c.name), '">', (opt_data.c.required && opt_data.c.required.patient_count) ? soy.$$escapeHtml(opt_data.c.required.patient_count) + ' patient' + ((opt_data.c.required.patient_count != 1) ? 's' : '') : '', '</td>');
  el8.template.appanalytics.reports.mu.rowComputedPercentage({c: opt_data.c}, output);
  el8.template.appanalytics.reports.mu.rowNumerator({c: opt_data.c}, output);
  el8.template.appanalytics.reports.mu.rowDenominator({c: opt_data.c}, output);
  el8.template.appanalytics.reports.mu.rowViewListBtn({c: opt_data.c}, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.checkbox = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.appanalytics.reports.mu.rowLabel({c: opt_data.c, show_check: opt_data.c.required.bool_value == opt_data.c.data.bool_value}, output);
  el8.template.appanalytics.reports.mu.rowMeasureType({c: opt_data.c}, output);
  output.append('<td class="required-bool el8EmphasisText', (opt_data.c.inactive) ? ' el8DismissTextImportant' : '', '" data-name="', soy.$$escapeHtml(opt_data.c.name), '">', (opt_data.c.required.bool_value == true) ? 'See Description' : 'No', '</td><td>--</td><td>--</td><td>--</td><td></td>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.muReportTitle = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h2 class="el8ReportTitle">', soy.$$escapeHtml(opt_data.title), ' For ', (opt_data.period == 'NINETY_DAY') ? '90 Day Period Ending on: ' + soy.$$escapeHtml(opt_data.end_date) : (opt_data.period == 'QUARTERLY') ? 'Quarterly' : (opt_data.period == 'CALENDAR_YEAR') ? 'Annual' : (opt_data.period == 'SEVEN_DAY') ? '7 Day Period Ending on: ' + soy.$$escapeHtml(opt_data.end_date) : '', '</h2>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.muReportTable = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<tr class="reportCategory"><td colspan="', (opt_data.col_count) ? soy.$$escapeHtml(opt_data.col_count) : '7', '">', soy.$$escapeHtml(opt_data.name), (opt_data.desc) ? ' <span class="el8SystemText">' + soy.$$escapeHtml(opt_data.desc) + '</span>' : '', '</td></tr>');
  var rowList456 = opt_data.list;
  var rowListLen456 = rowList456.length;
  for (var rowIndex456 = 0; rowIndex456 < rowListLen456; rowIndex456++) {
    var rowData456 = rowList456[rowIndex456];
    output.append('<tr class="el8ItemHover" data-name="', soy.$$escapeHtml(rowData456.name), '">');
    if (! rowData456.required || rowData456.required.percent) {
      el8.template.appanalytics.reports.mu.percent({c: rowData456}, output);
    } else if (rowData456.required.patient_count) {
      el8.template.appanalytics.reports.mu.patient_count({c: rowData456}, output);
    } else {
      el8.template.appanalytics.reports.mu.checkbox({c: rowData456}, output);
    }
    output.append('</tr>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.rowLabel = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<td class="reportIndicatorName', (opt_data.c.inactive) ? ' el8DismissTextImportant' : '', '"><span class="measure-icon">');
  if (opt_data.show_check) {
    el8.template.appanalytics.reports.mu.checkGoodIcon(null, output);
  }
  output.append('</span><p class="el8StandardFontSize el8ItemIconPadding">');
  if (opt_data.c.support_url) {
    output.append('<a target="_blank" rel="noopener" href="', soy.$$escapeHtml(opt_data.c.support_url), '">');
    el8.template.appanalytics.reports.mu.rowLabelText({c: opt_data.c}, output);
    output.append('</a>');
  } else {
    el8.template.appanalytics.reports.mu.rowLabelText({c: opt_data.c}, output);
  }
  output.append('</p></td>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.rowLabelText = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div>', (opt_data.c.set == 'core') ? 'C.' : (opt_data.c.set == 'menu') ? 'M.' : '', (opt_data.c.number) ? soy.$$escapeHtml(opt_data.c.number) + '. ' : '', soy.$$escapeHtml(opt_data.c.label), '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.checkGoodIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8ItemCheckGood"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.rowMeasureType = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.c.measure_type) ? '<td>' + soy.$$escapeHtml(opt_data.c.measure_type) + '</td>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.rowComputedPercentage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<td class="computed-percent', (opt_data.c.inactive) ? ' el8DismissTextImportant' : '', '" data-name="', soy.$$escapeHtml(opt_data.c.name), '">', (opt_data.c.data.percent) ? soy.$$escapeHtml(opt_data.c.data.percent) + '%' : (opt_data.c.data.num == null || opt_data.c.data.den == null) ? '?' : '--', '</td>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.rowNumerator = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<td class="computed-num', (opt_data.c.inactive) ? ' el8DismissTextImportant' : '', '" data-name="', soy.$$escapeHtml(opt_data.c.name), '">', soy.$$escapeHtml(opt_data.c.data.num), '</td>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.rowDenominator = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<td class="computed-den', (opt_data.c.inactive) ? ' el8DismissTextImportant' : '', '" data-name="', soy.$$escapeHtml(opt_data.c.name), '">', soy.$$escapeHtml(opt_data.c.data.den), '</td>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.rowViewListBtn = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<td class="el8ActionColumn"><button type="button" class="view-mu-numden-trigger el8ItemButton2" data-name="', soy.$$escapeHtml(opt_data.c.name), '" data-csv-url="', soy.$$escapeHtml(opt_data.c.csv_url), '" data-den-metric-url="', soy.$$escapeHtml(opt_data.c.data.den_metric_url), '" data-num-metric-url="', soy.$$escapeHtml(opt_data.c.data.num_metric_url), '">View List</button></td>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appanalytics.reports.mu.placeholderReport = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<h3 class="mt10">Note: this is a sample <a href="https://help.elationhealth.com/s/topic/0TO1G0000008qAsWAI/meaningful-use" target="_blank" rel="noopener">Meaningful Use report</a>. Subscribe to Elation Health to activate this report for your practice.</h3><img src="/static/images/sample_mu_report.png" alt="Sample Report" /><h3 class="mb10">Note: this is a sample <a href="https://help.elationhealth.com/s/topic/0TO1G0000008qAsWAI/meaningful-use" target="_blank" rel="noopener">Meaningful Use report</a>. Subscribe to Elation Health to activate this report for your practice.</h3>');
  if (!opt_sb) return output.toString();
};
